import React, { Component } from 'react';

import { post, api, getBranchOwner } from '@config'

import PersonAdaptToClient from '@parts/person/personAdaptToClient'
import UploadDigitalCertificate from '../../fiscal/digital-certificate/upload-certificate'
import { notification } from 'antd'; 

class RegisterCertificate extends Component {
    constructor(props) {
        super(props);
        this.state = { file: null, pwd: "", branch_created: false }

        this.onUpload = this.onUpload.bind(this)
        this.onChangePwd = this.onChangePwd.bind(this)
        this.create = this.create.bind(this)
    }

    onUpload(file) { this.setState({ file }) }
    onChangePwd(pwd) { this.setState({ pwd }) }

    uploadCert(branch_id) {
        const formData = new FormData();
        formData.append("branch_owner", branch_id);
        formData.append("password", this.state.pwd);
        formData.append("file", this.state.file);
        const url = `${api.certificates}?branch_owner=${branch_id}`;

        function payload(resp) {
            notification.open({
                message: "Cliente cadastrado com sucesso!",
                type: "success",
                key: 2,
                duration: 3
            })
            setTimeout(() => {
                window.location.href = '/accountant/clients/list'
            }, 3000);
        }
        function errPayload(err) {
            notification.open({
                message: "Erro ao cadastrar",
                description: "Verifique os dados e tente novamente.",
                type: "error",
                key: 2,
                duration: 3
            })
        }

        post(url, formData, payload, errPayload);

    }
    create(data) {
        const { file, pwd } = this.state
        if (file == null || pwd == "") {
            notification.open({
                type: "error",
                message: "Erro ao cadastrar o certificado!",
                description: "Verifique os dados e tente novamente",
                key: 93
            })
            return
        }

        const branchPayload = (resp) => {
            this.uploadCert(resp.id)
        }
        const branchErrPayload = (err) => {
        }

        post(api.branches, data, branchPayload, branchErrPayload)
    }

    render() {
        return (
            <div>
                <h3>Certificado</h3>
                <UploadDigitalCertificate onUpload={this.onUpload} onChangePassword={this.onChangePwd} />

                {this.state.branch_created ? (
                    <div>
                        <h3>Dados do Cliente</h3>
                        <h2 className='text-center'>Cliente Criado</h2>                    
                    </div>
                ) :
                    <PersonAdaptToClient mei createBranch={this.create} />
                }
            </div>
        );
    }
}

export default RegisterCertificate;


// WEBPACK FOOTER //
// ./src/components/pages/accountant/registerCertificate/index.jsx